import { render, staticRenderFns } from "./References.vue?vue&type=template&id=e08a3e1a&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"
import style0 from "./References.vue?vue&type=style&index=0&id=e08a3e1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a3e1a",
  null
  
)

export default component.exports